import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-ngx-generic-modal',
  templateUrl: './ngx-generic-modal.component.html',
  styleUrls: ['./ngx-generic-modal.component.css'],
  standalone: false
})
export class NgxGenericModalComponent implements OnInit {
  public title: string;
  public message: string;
  public yesButton = $localize`Yes`;
  public noButton = $localize`No`;
  public okButton = $localize`Ok`
  public displayOkButton = false;

  constructor(protected ref: NbDialogRef<NgxGenericModalComponent>) {}

  public ngOnInit() {}

  public clickedYes() {
    this.ref.close(true);
  }

  public clickedNo() {
    this.ref.close(false);
  }
}
